(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('MaterialTypeDetailController', MaterialTypeDetailController);

    MaterialTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MaterialType', 'User'];

    function MaterialTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, MaterialType, User) {
        var vm = this;

        vm.materialType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:materialTypeUpdate', function(event, result) {
            vm.materialType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
